export const getFiltersProductsSelector = state => state.filters.filtersProducts;
export const getFiltersIsLoadingSelector = state => state.filters.isLoading;
